module.exports = __webpack_public_path__ + "img/BankPoalim45.0335a696.png";